import(/* webpackMode: "eager", webpackExports: ["ClientTicker"] */ "/vercel/path0/app/_components/marketing/client-ticker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_components/marketing/team-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/bg-lined.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/team.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/(header-and-footer)/(home)/components/logo-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/(header-and-footer)/about/components/start-conversation-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
